<template>
  <div class="d-flex justify-content-center align-items-center mt-5">
    <div class="d-flex-col">
      <div class="mb-5 text-center">
        <!-- <font-awesome-icon icon="gear" class="me-3 mb-2 fa-3x" /> -->
        <img src="@/assets/icons/1a_connect.png" alt="Archiv Icon" width="256" />
        <h1>EW Web MES</h1>
      </div>

      <section>
        <form class="form-signin p-0" @submit.prevent="login">
          <div class="form-floating mb-3">
            <input
              type="text"
              class="form-control"
              id="floatingInput"
              placeholder="Anmeldename"
              autocomplete="username"
              v-model="loginData.username"
              required
            />
            <label for="floatingInput">Benutzername</label>
          </div>

          <div class="form-floating mb-3">
            <input
              type="password"
              class="form-control"
              id="floatingPassword"
              placeholder="Password"
              autocomplete="current-password"
              v-model="loginData.password"
              required
            />
            <label for="floatingPassword">Passwort</label>
          </div>

          <button type="submit" class="w-100 btn btn-lg btn-primary text-light">
            <font-awesome-icon icon="arrow-right-to-bracket" class="me-3" />
            Anmelden
          </button>
        </form>
      </section>

      <div v-if="commonStore.status.authErrorMsg != ''" class="alert alert-danger mt-3">{{ commonStore.status.authErrorMsg }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { ref } from 'vue';
  import { AuthRequest } from '@/models/AuthModels';
  import { useAuthStore } from '@/stores/authStore';
  import { useCommonStore } from '@/stores/commonStore';
  import { useRouter } from 'vue-router';
  //#endregion

  const router = useRouter();
  const authStore = useAuthStore();
  const commonStore = useCommonStore();

  const loginData = ref(new AuthRequest());

  function login() {
    authStore.login(loginData.value).then(() => {
      console.log(commonStore.status.authErrorMsg);
      if (commonStore.status.authErrorMsg == '') {
        console.log('Login successful');
        router.push({ name: 'Dashboard' });
      }
    });
  }
</script>
